import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    $onChanges() {
        this.init();
    }

    $onInit() {
        this.init();
        this.watch();
    }

    init() {
        this.$model = this.pushApprovalServicesConfiguration;
        this.model = angular.copy(this.$model);
    }

    notModified() {
        return angular.equals(this.$model, this.model);
    }

    onKeyUp($event) {
        if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
            this.onEnter();
        }
    }

    watch() {
        this.$scope.$watch(
            () => this.model,
            () => this.onChange({$value: this.model, $invalid: this.form.$invalid}),
            true
        );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/push-approval-services-form.controller.js